<template>
  <div v-loading.fullscreen.lock="loading">
    <h1 class="page-title">Order details</h1>

    <div class="row">
      <div class="col-md-12">
        <div class="portlet light portlet-fit bordered">
          <div class="portlet-title">
            <div class="caption">
              <i class="fa fa-search font-green-haze"></i>
              <span class="caption-subject font-green-haze bold uppercase">Search orders</span>
            </div>
          </div>
          <div class="portlet-body">
            <el-select v-model="searchBy" placeholder="Select">
              <el-option
                label="Search by email"
                value="email">
              </el-option>
              <el-option
                label="Search by order id"
                value="order_id">
              </el-option>
            </el-select>
            <p></p>
            <lod-order-search
              :searchBy="searchBy"
              @onOrderFound="onOrder"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="portlet light portlet-fit bordered">
          <div class="portlet-title">
            <div class="caption">
              <i class="fa fa-list font-green-haze"></i>
              <span class="caption-subject font-green-haze bold uppercase">Order details</span>
            </div>
          </div>
          <div class="portlet-body">
            <lod-orders-table
              :orders="orders"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* ============
   * Outbox Deals Component
   * ============
   *
   */
  import LodOrderSearch from '@/app/components/outbox/Search'
  import LodOrdersTable from '@/app/components/outbox/OrdersTable'

  const moment = require('moment')

  export default {
    components: {
      LodOrderSearch,
      LodOrdersTable
    },
    data () {
      return {
        loading: false,
        dataProvider: null,
        orders: [],
        searchBy: 'email'
      }
    },
    methods: {
      onOrder (orders) {
        if (!orders.length) {
          this.$notify.warning({
            title: 'Oups',
            message: 'Orders not found'
          })
        }

        // load order details
        this.getOrderDetails(orders)
          .then(responses => {
            this.orders = responses
              .map(res => {
                const data = res.data

                return {
                  json: JSON.stringify(data),
                  id: data.PK,
                  email: data.GUEST_USER_INFO.email,
                  eventName: data.ORDER_DETAIL.eventDescription.name,
                  amount: Math.round(data.ORDER_DETAIL.totalPrice) / 100,
                  date: moment.unix(data.ORDER_DETAIL.timestamp).format('YYYY-MM-DD HH:mm'),
                  status: data.ORDER_STATUS,
                  actionBtns: data.ORDER_STATUS === 'COMPLETED'
                    ? `<button class="btn blue btn-outline sbold uppercase" data-orderid="${data.PK}" data-action="resendTickets" href="javascript:;">Resend tickets</button><br><br>
                       <button class="btn red btn-outline sbold uppercase" data-orderid="${data.PK}" data-action="cancelOrder" href="javascript:;">Cancel order</button>`
                    : `<button class="btn red btn-outline sbold uppercase" data-orderid="${data.PK}" data-action="cancelOrder" href="javascript:;">Cancel order</button>`
                }
              })
          })
      },
      getOrderDetails (orders) {
        const url = `https://apigw-${process.env.CLO_PHP_API_ENV}.tuango.ca/lod-outbox-admin/orders`
        return Promise.all(orders.map(order => {
          return this.$http.get(url + '/' + order.id)
        }))
      }
    },
    created () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/pages/Localdeals/Outbox.vue